import type { Geopoint } from "@/lib/sanity/sanity.types";

/**
 * Build a Google Maps search URL from a geopoint, or null when the point
 * has no usable lat/lng (both are optional on the schema type). With a
 * Google Place ID, Maps opens that business listing instead of a bare pin.
 */
export function mapsUrl(
  coordinates: Partial<Geopoint> | null | undefined,
  placeId?: string | null,
): string | null {
  const lat = coordinates?.lat;
  const lng = coordinates?.lng;
  if (typeof lat !== "number" || typeof lng !== "number") return null;
  const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  const id = placeId?.trim();
  return id ? `${url}&query_place_id=${encodeURIComponent(id)}` : url;
}
